import React, { type FC } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { useIntl } from '@atlassian/jira-intl';
import { type IntentTemplateType, INTENT_TEMPLATE_TYPES } from '../../types';

import messages from './messages';

export const TemplateLozenge: FC<{ type: IntentTemplateType | undefined }> = ({ type }) => {
	const { formatMessage } = useIntl();

	switch (type) {
		case INTENT_TEMPLATE_TYPES.DISCOVERED: {
			return (
				<span>
					<Lozenge appearance="new">{formatMessage(messages.yourData)}</Lozenge>
				</span>
			);
		}
		case INTENT_TEMPLATE_TYPES.SHARED: {
			return (
				<span>
					<Lozenge appearance="success">{formatMessage(messages.catalog)}</Lozenge>
				</span>
			);
		}
		default: {
			return null;
		}
	}
};
